/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizernav1Inputs */

const en_organizernav1 = /** @type {(inputs: Organizernav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const de_organizernav1 = /** @type {(inputs: Organizernav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Organizernav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizernav1 = /** @type {((inputs?: Organizernav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizernav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizernav1(inputs)
	return de_organizernav1(inputs)
});
export { organizernav1 as "organizerNav" }